import * as React from "react";
import { AuthContext } from "src/components/context/AuthContext";
import { Redirect } from "react-router";
import { useEffect } from "react";

export const Logout = () => {
  const { signOut, isLoggedIn } = React.useContext(AuthContext);

  useEffect(() => {
    signOut();
  }, []);

  if (isLoggedIn()) {
    return <div />;
  }

  return <Redirect to="/login" />;
};



// WEBPACK FOOTER //
// ./src/pages/logout/Logout.tsx